import React from 'react';
import { Select } from 'antd';
import { Input, Rule } from '../../../../store/modules/rules';
import getRuleFieldValue from './utils/getRuleFieldValue';

interface IInputSelectProps {
  rule: Rule;
  input: Input;
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void;
}

const InputSelect = ({ input, rule, onChange }: IInputSelectProps): JSX.Element => {
  const { label, name } = input;

  return (
    <Select
      style={{ width: 250 }}
      placeholder={`Select ${label}`}
      value={getRuleFieldValue<string>(rule, name)}
      options={input.options}
      onChange={(value: string) => {
        onChange(value, rule, input);
      }}
    />
  );
};

export default InputSelect;
